/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the TrackCrateSearchDto interface.
 */
export function instanceOfTrackCrateSearchDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function TrackCrateSearchDtoFromJSON(json) {
    return TrackCrateSearchDtoFromJSONTyped(json, false);
}
export function TrackCrateSearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function TrackCrateSearchDtoToJSON(json) {
    return TrackCrateSearchDtoToJSONTyped(json, false);
}
export function TrackCrateSearchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
